import moment from 'moment';

const MILISECONDS_IN_A_DAY = 86400000;

export const getDaysBetweenDates = (dateA, dateB) =>
	Math.floor(moment(dateA).diff(dateB) / MILISECONDS_IN_A_DAY);
